<script lang="ts">
	import Link from '$lib/components/atoms/link/Link.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import * as m from '$paraglide/messages';
	import DatasheetDetailBlock from './DatasheetDetailBlock.svelte';

	interface Props {
		phone?: string;
		website?: string;
		infos?: (string | null)[];
	}

	const {
		phone,
		website,
		infos,
	}: Props = $props();
</script>

<DatasheetDetailBlock title={m.poi_datasheet__practical_info()}>
	{#if phone}
		<div class="flex flex-row gap-2 items-center">
			<Icon icon="call" />
			<div>{phone}</div>
		</div>
	{/if}
	{#if website}
		<div class="flex flex-row gap-2 items-center overflow-hidden">
			<Icon icon="captive-portal" class="shrink-0" />
			<Link
				href={website}
				label={website}
				onclick={() => track({ action: 'datasheet_contacts', payload: { action: 'click' } })}
				target="_blank"
				rel="external"
			/>
		</div>
	{/if}
	{#if infos && infos.filter(info => info).length}
		<ul class="mb-0 pl-4" style="list-style-type: disc">
			{#each infos as info (info)}
				{#if info}<li>{info}</li>{/if}
			{/each}
		</ul>
	{/if}
</DatasheetDetailBlock>
